/**
 * コマンドハンドラの登録
 *
 * JSON-basedコマンドインターフェース:
 * - x:tab - タブを開く/更新
 * - x:dataset - DerivedDataSetを作成（SQL, Filter, Crosstab）
 * - x:report - レポートに要素を追加（グラフ、テキスト、統計）
 * - x:model - GLMタブを設定済みで開く
 * - x:status - プロジェクト状態を取得
 * - x:list - リソース一覧を取得
 * - x:describe - データセット詳細を取得
 */

import { commandRegistry } from '../CommandRegistry';
import { tabHandler } from './tab';
import { datasetHandler } from './dataset';
import { reportHandler } from './report';
import { modelHandler } from './model';
import { statusHandler } from './status';
import { listHandler } from './list';
import { describeHandler } from './describe';

// 全ハンドラを登録
export function registerAllHandlers(): void {
  commandRegistry.register(tabHandler);
  commandRegistry.register(datasetHandler);
  commandRegistry.register(reportHandler);
  commandRegistry.register(modelHandler);
  commandRegistry.register(statusHandler);
  commandRegistry.register(listHandler);
  commandRegistry.register(describeHandler);
}

// ハンドラを個別にエクスポート（テスト用）
export {
  tabHandler,
  datasetHandler,
  reportHandler,
  modelHandler,
  statusHandler,
  listHandler,
  describeHandler
};
